<script lang="ts">
  import { hideHelp, help } from "../stores";
</script>

{#if $help}
  <div on:click={hideHelp} />
{/if}

<style>
  div {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5;
  }
</style>
